import CanvasScrollClip from "canvas-scroll-clip";

(function( $ ) {
  if ($('.sequence').length > 0) {
    $('.sequence').each(function() {
      let that= $(this);
      new CanvasScrollClip(that[0], {
        framePath: that.data('image'),
        frameCount: that.data('frames'),
        //scrollArea: 100
      })
    });
  }
})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partials/sequences.js